export default [
  {
    name: 'find/id',
    path: '/find/id',
    meta: { requireSignin: false, design: { classes: ['fill-height', 'bg--linear-gradient'] } },
    component: () => import('@/pages/find/Id.vue'),
  },
  {
    name: 'find/password',
    path: '/find/password',
    meta: { requireSignin: false, design: { classes: ['fill-height', 'bg--linear-gradient'] } },
    component: () => import('@/pages/find/Password.vue'),
  },
]
